// Types
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_ALERT = 'SHOW_ALERT';
export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const SHOW_LINK_CONFIRM = 'SHOW_LINK_CONFIRM';
export const SHOW_TOAST = 'SHOW_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const CONFIRM_MODAL = 'CONFIRM_MODAL';
export const CANCEL_MODAL = 'CANCEL_MODAL';
export const ADD_MODAL = 'ADD_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const INIT_STORE = 'INIT_STORE';

export const SHOW_JOIN_AGREE_BOTTOM_SHADOW = 'SHOW_JOIN_AGREE_BOTTOM_SHADOW';

export const SET_LOADING = 'SET_LOADING';
export const SET_LOCK_SCREEN = 'SET_LOCK_SCREEN';
export const SET_IS_ENLARGE_FONT = 'SET_IS_ENLARGE_FONT';
export const SET_GOOGLE_API_INFO = 'SET_GOOGLE_API_INFO';
export const RESET_GOOGLE_API_INFO = 'RESET_GOOGLE_API_INFO';
export const SET_IS_POPUP_DISPLAYED = 'SET_IS_POPUP_DISPLAYED';
export const RESET_IS_POPUP_DISPLAYED = 'RESET_IS_POPUP_DISPLAYED';

export const SAVE_IN_PROGRESS = 'SAVE_IN_PROGRESS';

export const ADD_KEY_STROKE_TARGET = 'ADD_KEY_STROKE_TARGET';
export const REMOVE_KEY_STROKE_TARGET = 'REMOVE_KEY_STROKE_TARGET';

export const SEARCH_JOB_INFO = 'SEARCH_JOB_INFO';
export const SEARCH_JOB_DRIVER_INFO = 'SEARCH_JOB_DRIVER_INFO';
export const SEARCH_JOB_INFO_SUCCESS = 'SEARCH_JOB_INFO_SUCCESS';
export const SEARCH_DRIVER_INFO_SUCCESS = 'SEARCH_DRIVER_INFO_SUCCESS';
export const INIT_JOB_DRIVER_INFO = 'INIT_JOB_DRIVER_INFO';
export const SEARCH_BOOKMARK_JOB_INFO = 'SEARCH_BOOKMARK_JOB_INFO';
export const SEARCH_BOOKMARK_JOB_INFO_SUCCESS =
  'SEARCH_BOOKMARK_JOB_INFO_SUCCESS';

export const GET_EDU_GA_SMS = 'GET_EDU_GA_SMS';
export const SAVE_FINANCE_CUSTOMER_INFO = 'SAVE_FINANCE_CUSTOMER_INFO';

export const SET_CODE_INFO = 'SET_CODE_INFO';
export const FETCH_CODE_INFO = 'FETCH_CODE_INFO';
export const SET_SESSION_ID = 'SET_SESSION_ID';

export const SET_LOGIN_TIMER_INFO = 'SET_LOGIN_TIMER_INFO';

export const GET_HQ_LIST_BY_CHANNEL = 'GET_HQ_LIST_BY_CHANNEL';
export const GET_AGENCY_LIST_BY_HQ = 'GET_AGENCY_LIST_BY_HQ';

export const GET_HQ_LIST_BY_CHANNEL_SUCCESS = 'GET_HQ_LIST_BY_CHANNEL_SUCCESS';
export const GET_AGENCY_LIST_BY_HQ_SUCCESS = 'GET_AGENCY_LIST_BY_HQ_SUCCESS';

export const GET_HQ_AGENCY_CLEAR = 'GET_HQ_AGENCY_CLEAR';

export const CREATE_ERR_LOG = 'CREATE_ERR_LOG';

export const SHOW_EXCEPTION_MODAL = 'SHOW_EXCEPTION_MODAL';
export const HIDE_EXCEPTION_MODAL = 'HIDE_EXCEPTION_MODAL';

// Track2
export const SET_DEVICE_MODE = 'SET_DEVICE_MODE';
export const SET_EXTERNAL_POPUP = 'SET_EXTERNAL_POPUP';
export const FORCE_UPDATE_APP = 'FORCE_UPDATE_APP';
export const REMOVE_INTRO_MOVIE = 'REMOVE_INTRO_MOVIE';
export const SHOW_JOB_DRIVER_MODAL = 'SHOW_JOB_DRIVER_MODAL';
export const HIDE_JOB_DRIVER_MODAL = 'HIDE_JOB_DRIVER_MODAL';

// 상벌점에 따라 가입설계 설계목록 막기
export const CHECK_RDOP_CONT = 'CHECK_RDOP_CONT';
export const CHECK_RDOP_CONT_SUCCESS = 'CHECK_RDOP_CONT_SUCCESS';

// Device 관련 Actions
export const SET_IS_PORTRAIT = 'SET_IS_PORTRAIT';

// Local 개발용 API 서버 변경
export const SET_DEV_SERVER_TYPE = 'SET_DEV_SERVER_TYPE';
export const SET_LOCAL_SERVER_INFO = 'SET_LOCAL_SERVER_INFO';

// 현재 매뉴 저장
export const SET_MENU_INFO = 'SET_MENU_INFO';

// 사전심사 고도화 (PRE-UW) ================>
// 이벤트 날짜 셋팅
export const SET_EVENT_DATE = 'SET_EVENT_DATE';
// LOS 공통 코드 조회
export const GET_LOS_CODE_INFO = 'GET_LOS_CODE_INFO';
// LOS 공통 코드 단건 셋팅
export const SET_LOS_CODE_INFO = 'SET_LOS_CODE_INFO';

export const GET_DISEASE_LIST = 'GET_DISEASE_LIST';
export const SET_DISEASE_LIST = 'SET_DISEASE_LIST';
export const GET_DISEASE_INFO = 'GET_DISEASE_INFO';
export const SET_DISEASE_INFO = 'SET_DISEASE_INFO';

// Actions ================>
export const showModal = payload => {
  return { type: SHOW_MODAL, payload };
};
export const showAlert = payload => {
  return { type: SHOW_ALERT, payload };
};
export const showConfirm = payload => {
  return { type: SHOW_CONFIRM, payload };
};
export const showLinkConfirm = payload => {
  return { type: SHOW_LINK_CONFIRM, payload };
};
export const showToast = payload => {
  return { type: SHOW_TOAST, payload };
};
export const removeToast = payload => {
  return { type: REMOVE_TOAST, payload };
};
export const hideModal = payload => {
  return { type: HIDE_MODAL, payload };
};
export const confirmModal = callback => {
  return { type: CONFIRM_MODAL, callback };
};
export const cancelModal = callback => {
  return { type: CANCEL_MODAL, callback };
};
export const addModal = payload => {
  return { type: ADD_MODAL, payload };
};
export const removeModal = payload => {
  return { type: REMOVE_MODAL, payload };
};
export const initStore = payload => {
  return { type: INIT_STORE, payload };
};
export const setGoogleApiInfo = payload => {
  return { type: SET_GOOGLE_API_INFO, payload };
};
export const resetGoogleApiInfo = payload => {
  return { type: RESET_GOOGLE_API_INFO, payload };
};
export const setShowJoinAgreeBottomShadow = payload => {
  return { type: SHOW_JOIN_AGREE_BOTTOM_SHADOW, payload };
};
export const setLoading = payload => {
  return { type: SET_LOADING, payload };
};
export const setLockScreen = payload => {
  return { type: SET_LOCK_SCREEN, payload };
};
export const setIsEnlargeFont = payload => {
  return { type: SET_IS_ENLARGE_FONT, payload };
};
export const setIsPopupDisplayed = payload => {
  return { type: SET_IS_POPUP_DISPLAYED, payload };
};
export const resetIsPopupDisplayed = payload => {
  return { type: RESET_IS_POPUP_DISPLAYED, payload };
};

// 직업, 운전정보 관련
export const searchJobNDriverInfo = data => {
  return { type: SEARCH_JOB_DRIVER_INFO, payload: data };
};

export const searchJobInfo = data => {
  return { type: SEARCH_JOB_INFO, payload: data };
};

export const initJobNDriverInfo = payload => {
  return { type: INIT_JOB_DRIVER_INFO, payload };
};

export const searchBookMarkJobInfo = payload => {
  return { type: SEARCH_BOOKMARK_JOB_INFO, payload };
};

export const saveInProgress = payload => {
  return { type: SAVE_IN_PROGRESS, payload };
};

export const addKeyStrokeTarget = payload => {
  return { type: ADD_KEY_STROKE_TARGET, payload };
};

export const removeKeyStrokeTarget = payload => {
  return { type: REMOVE_KEY_STROKE_TARGET, payload };
};

export const getEduGASms = payload => {
  return { type: GET_EDU_GA_SMS, payload };
};

export const saveFinanceCustomerInfo = payload => {
  return { type: SAVE_FINANCE_CUSTOMER_INFO, payload };
};

export const getCodeInfo = payload => {
  return { type: FETCH_CODE_INFO, payload };
};

export const setCodeInfo = payload => {
  return { type: SET_CODE_INFO, payload };
};

export const setSessionId = payload => {
  return { type: SET_SESSION_ID, payload };
};

export const setLoginTimerInfo = payload => {
  return { type: SET_LOGIN_TIMER_INFO, payload };
};

export const getHqListByChannel = data => {
  return { type: GET_HQ_LIST_BY_CHANNEL, payload: data };
};

export const getAgencyListByHq = data => {
  return { type: GET_AGENCY_LIST_BY_HQ, payload: data };
};

export const getHqAgencyClear = data => {
  return { type: GET_HQ_AGENCY_CLEAR, payload: data };
};

export const createErrLog = data => {
  return { type: CREATE_ERR_LOG, payload: data };
};

export const showExceptionModal = data => {
  return { type: SHOW_EXCEPTION_MODAL, payload: data };
};

export const hideExceptionModal = data => {
  return { type: HIDE_EXCEPTION_MODAL, payload: data };
};

export const setDeviceMode = data => {
  return { type: SET_DEVICE_MODE, payload: data };
};

export const setExternalPopup = data => {
  return { type: SET_EXTERNAL_POPUP, payload: data };
};

export const forceUpdateApp = data => {
  return { type: FORCE_UPDATE_APP, payload: data };
};

export const removeIntroMovie = () => {
  return { type: REMOVE_INTRO_MOVIE };
};

export const showJobDriverModal = data => {
  return { type: SHOW_JOB_DRIVER_MODAL, payload: data };
};

export const hideJobDriverModal = data => {
  return { type: HIDE_JOB_DRIVER_MODAL, payload: data };
};

// 상벌점에 따라 가입설계 설계목록 막기
export const checkRdopCont = data => {
  return { type: CHECK_RDOP_CONT, payload: data };
};

// Device 관련 Actions
export const setIsPortrait = data => {
  return { type: SET_IS_PORTRAIT, payload: data };
};

// Local 개발용 API 서버 변경
export const setDevServerType = data => {
  return { type: SET_DEV_SERVER_TYPE, payload: data };
};
export const setLocalServerInfo = data => {
  return { type: SET_LOCAL_SERVER_INFO, payload: data };
};

// 현재 메뉴 저장
export const setMenuInfo = data => {
  return { type: SET_MENU_INFO, payload: data };
};

// 사전심사 고도화 (PRE-UW) ================>
// 이벤트 날짜 셋팅
export const setEventDate = payload => ({ type: SET_EVENT_DATE, payload });
// LOS 공통 코드 조회
export const getLosCodeInfo = payload => ({
  type: GET_LOS_CODE_INFO,
  payload,
});
// LOS 공통 코드 셋팅
export const setLosCodeInfo = payload => ({
  type: SET_LOS_CODE_INFO,
  payload,
});

export const getDiseaseList = payload => ({
  type: GET_DISEASE_LIST,
  payload,
});

export const getDiseaseInfo = payload => ({
  type: GET_DISEASE_INFO,
  payload,
});
